module.exports = __webpack_public_path__ + "static/mahmoodi-2a814ea22a450e83feaea82b783d9fb4.jpg";